<template>
  <div class="yzm-textpicture" :style="{ ...marginStyle }">
    <div class="flex" v-if="item.setting?.layoutType == 0">
      <el-image fit="cover" class="flex-1" :src="item.setting?.imgUrl" :style="{ ...borderStyle }" />
      <div class="text flex-1" :style="{ ...textStyle }" style="margin-left: 8px">{{ item.setting?.title }}</div>
    </div>
    <div class="flex" v-if="item.setting?.layoutType == 1">
      <div class="text flex-1" :style="{ ...textStyle }" style="margin-right: 8px">{{ item.setting?.title }}</div>
      <el-image fit="cover" class="flex-1" :src="item.setting?.imgUrl" :style="{ ...borderStyle }" />
    </div>
    <div class="flex flex-column" v-if="item.setting?.layoutType == 2">
      <el-image fit="cover" class="flex-1" :src="item.setting?.imgUrl" :style="{ ...borderStyle }" />
      <div class="text flex-1" :style="{ ...textStyle }" style="margin-top: 8px">{{ item.setting?.title }}</div>
    </div>
    <div class="flex flex-column" v-if="item.setting?.layoutType == 3">
      <div class="text flex-1" :style="{ ...textStyle }" style="margin-bottom: 8px">{{ item.setting?.title }}</div>
      <el-image fit="cover" class="flex-1" :src="item.setting?.imgUrl" :style="{ ...borderStyle }" />
    </div>
  </div>
</template>
<script setup>
import { defineProps, computed, onMounted, defineEmits } from 'vue'
import { defaultProps } from './defaultProps'
const props = defineProps({
  ...defaultProps
})
const marginStyle = computed(() => {
  let item = props.item.setting
  return {
    marginTop: `${item.marginTop}px`,
    marginBottom: `${item.marginBottom}px`,
    marginLeft: `${item.marginLeft}px`,
    marginRight: `${item.marginRight}px`
  }
})
const borderStyle = computed(() => {
  let item = props.item.setting
  return {
    borderTopLeftRadius: `${item.borderTopLeftRadius}px`,
    borderBottomLeftRadius: `${item.borderBottomLeftRadius}px`,
    borderTopRightRadius: `${item.borderTopRightRadius}px`,
    borderBottomRightRadius: `${item.borderBottomRightRadius}px`
  }
})
const textStyle = computed(() => {
  let item = props.item.setting
  return {
    fontSize: `${item.fontSize}px`,
    color: item.color
  }
})
const emit = defineEmits(['childMounted'])
onMounted(() => {
  emit('childMounted')
})
</script>
<style lang="less" scoped>
.yzm-textpicture {
  .text {
    font-size: 12px;
    color: #888888;
  }
}
</style>
